import request from '@/utils/request'
/**
 * 初始化3d编辑器
 * @param {Object} data 
 * @returns 
 */
export function initEditor(data) {
    return request({
        url: '/editor/initEditor',
        method: 'POST',
        data,
    })
}
/**
 * 场景复制
 * @param {Object} data 
 * @returns 
 */
export function copyEditor(id) {
    return request({
        url: '/editor/copyEditor/' + id,
        method: 'POST',
    })
}
/**
 * 场景信息修改
 * @param {Object} data 
 * @returns 
 */
export function saveEditorInfo(data) {
    return request({
        url: '/editor/saveEditorInfo',
        method: 'POST',
        data,
    })
}

/**
 * 查询场景列表
 * @param {String} course 
 * @returns 
 */
 export function queryList(course) {
    return request({
        url: `/editor/query/course/${course}/editor`,
        method: 'GET',
    })
}

/**
 * 查询视角列表
 * @param {String} project 
 * @returns 
 */
 export function queryCameraPositionList(id) {
    return request({
        url: `/editor/query/camera/${id}/editor`,
        method: 'GET',
    })
}

/**
 * 查询场景列表
 * @param {String} project 
 * @returns 
 */
 export function removeEditor(id) {
    return request({
        url: `/editor/remove/${id}`,
        method: 'post',
    })
}

